import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'personalDataRequestStatus',
    pure: false,
})
export class PersonalDataRequestStatusPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(status: number): any {
        switch (status) {
            case 1:
                return this.translateService.instant('Created');
            case 2:
                return this.translateService.instant('Read by user');
            case 3:
                return this.translateService.instant('Request submitted');
            case 4:
                return this.translateService.instant('Archived');
            default:
                return '';
        }
    }
}
